export default __webpack_public_path__ + "static/media/widget-expand.5ca698e7.svg";